export default {
    commerces: [],
    pendingToRequest: []
  }
